// components/BlogCard.tsx
import React from 'react';
import styles from './BlogCard.module.scss'; // Ajuste o caminho conforme necessário
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

type BlogCardProps = {
    title: string;
    excerpt: string;
    tags?: string[];
    date: string;
    imageUrl?: string;
    postUrl?: string; // Adicionado para manter a consistência com o BlogPage
};

const BlogCard: React.FC<BlogCardProps> = ({ title, excerpt, date, tags, imageUrl, postUrl }) => {
    return (
        <Container className={styles["blog-card"]}>
            <Row>
                <Col xs={12} md={4} className={styles["image-col"]}>
                    <Link to={postUrl || '#'}>
                        <div className={styles["image-wrapper"]}>
                            {imageUrl && (
                                <img src={imageUrl} alt={title} className={styles["blog-image"]} />
                            )}
                        </div>
                    </Link>
                </Col>
                <Col xs={12} md={8} className={styles["content"]}>
                    <p className={styles["category"]}>
                        {tags && tags.length > 0 ? tags.join(', ') : 'Sem categorias'}
                    </p>
                    <Link to={postUrl || '#'}><h2 className={styles["title"]}>{title}</h2></Link>
                    <p className={styles["excerpt"]}>{excerpt}</p>
                    <p className={styles["date"]}>{date}</p>
                </Col>
            </Row>
        </Container>
    );
};

export default BlogCard;
